import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  Box,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface TestResultDialogProps {
  open: boolean;
  testResult: any;
  onClose: () => void;
}

export default function TestResultDialog({
  open,
  testResult,
  onClose,
}: TestResultDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{t('chatConfig.dialog.testResultTitle')}</DialogTitle>
      <DialogContent>
        {testResult && (
          <Box>
            <Alert severity={testResult.success ? 'success' : 'error'} sx={{ mb: 2 }}>
              {testResult.message}
            </Alert>
            {testResult.test_result && (
              <Box>
                <Typography variant="h6" gutterBottom>Test Results</Typography>
                <pre style={{ 
                  backgroundColor: '#f5f5f5', 
                  padding: '16px', 
                  borderRadius: '4px', 
                  overflow: 'auto' 
                }}>
                  {JSON.stringify(testResult.test_result, null, 2)}
                </pre>
              </Box>
            )}
            {testResult.error && (
              <Box>
                <Typography variant="h6" gutterBottom>Error Details</Typography>
                <Typography variant="body2" color="error">
                  {testResult.error}
                </Typography>
              </Box>
            )}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('chatConfig.dialog.close')}</Button>
      </DialogActions>
    </Dialog>
  );
}